import request from "@/utils/interceptor.js";

const auth = {
  // 登录
  login(data) {
    return request({ url: "/api/pas/auth/access-login", method: "post", data });
  },
  // 获取验证码
  getCaptcha(captchaId) {
    return request({
      url: `/api/pas/auth/generate-captcha/${captchaId}`,
      method: "get",
    });
  },
  // 刷新token
  refreshToken(data) {
    return request({ url: "/api/pas/auth/refresh-token", method: "post", data });
  },
  // 获取路由菜单(分页)
  getMenus(params) {
    return request({ url: "/api/pas/menu", method: "get", params });
  },
  // 新增路由菜单权限
  addMenus(data) {
    return request({ url: "/api/pas/menu", method: "post", data });
  },
  // 更新路由权限
  updateMenus(id, data) {
    return request({ url: `/api/pas/menu/${id}`, method: "put", data });
  },
  // 删除路由权限
  deleteMenus(id) {
    return request({ url: `/api/pas/menu/${id}`, method: "delete" });
  },
  // 获取角色列表
  getRoleList(params) {
    return request({ url: "/api/pas/role-info", method: "get", params });
  },
  // 新增角色
  addRole(data) {
    return request({ url: "/api/pas/role-info", method: "post", data });
  },
  // 编辑角色
  editRole(id, data) {
    return request({ url: `/api/pas/role-info/${id}`, method: "put", data });
  },
  // 编辑角色
  deleteRole(id) {
    return request({ url: `/api/pas/role-info/${id}`, method: "delete" });
  },
  // 获取角色菜单权限
  getRoleMenu(params) {
    return request({
      url: `/api/pas/role-menu`,
      method: "get",
      params,
    });
  },
  // 获取角色菜单权限
  getRolePermissionList(data) {
    return request({
      url: `/api/pas/role-menu/roles-list`,
      method: "post",
      data,
    });
  },
  // 给角色绑定菜单权限
  bindMenus(data) {
    return request({ url: `/api/pas/role-menu/list`, method: "post", data });
  },

  // 获取用户列表
  getUserList(params) {
    return request({ url: "/api/pas/user", method: "get", params });
  },
  // 新增用户
  addUser(data) {
    return request({ url: "/api/pas/user", method: "post", data });
  },
  // 编辑用户
  editUser(data) {
    return request({ url: `/api/pas/user/${data.id}`, method: "put", data });
  },
  // 删除用户
  deleteUser(id) {
    return request({ url: `/api/pas/user/${id}`, method: "delete" });
  },
  // 用户绑定角色
  bindRole(data) {
    return request({ url: `/api/pas/user-and-role/list`, method: "post", data });
  },
  // 查询用户绑定的角色
  getUserRoleList(id) {
    const params = {
      SkipCount: 0,
      MaxResultCount: 1000,
      UserId: id,
    };
    return request({ url: `/api/pas/user-and-role`, method: "get", params });
  },

  // 数据操作权限
  getPermissionList() {
    return request({
      url: "/api/pas/sys-permission/permission-all",
      method: "get",
    });
  },
  // 查询角色的权限
  getRolePermission(roleId) {
    return request({
      url: `/api/pas/sys-permission/grant-role-permission/${roleId}`,
      method: "get",
    });
  },
  // 设置角色权限
  setRolePermission(data) {
    return request({
      url: `/api/pas/sys-permission/grant-role-permission`,
      method: "post",
      data,
    });
  },
};

export default auth;
